import { jsx } from "@builder.io/qwik/jsx-runtime";
import { component$, useContext, $, useOnWindow, Slot } from "@builder.io/qwik";
import { collapsibleContextId } from "./collapsible-context.qwik.mjs";
const HCollapsibleTrigger = component$(({ onClick$, ...props }) => {
  const context = useContext(collapsibleContextId);
  const contentId = `${context.itemId}-content`;
  const triggerId = `${context.itemId}-trigger`;
  const handleClick$ = $(async () => {
    if (context.isOpenSig.value && context.collapsible === false)
      return;
    context.isOpenSig.value = !context.isOpenSig.value;
  });
  useOnWindow("resize", context.getContentDimensions$);
  return /* @__PURE__ */ jsx("button", {
    ...props,
    id: triggerId,
    ref: context.triggerRef,
    disabled: context.disabled,
    "data-disabled": context.disabled ? "" : void 0,
    "aria-disabled": context.disabled ? "true" : "false",
    "data-open": context.isOpenSig.value ? "" : void 0,
    "data-closed": !context.isOpenSig.value ? "" : void 0,
    "aria-expanded": context.isOpenSig.value,
    "aria-controls": contentId,
    onClick$: [
      handleClick$,
      onClick$
    ],
    children: /* @__PURE__ */ jsx(Slot, {})
  });
});
export {
  HCollapsibleTrigger
};
